<template>
  <div class="add-rule-modal">
    <el-dialog
      :title="modalType === 'edit' ? '编辑规则' : modalType === 'add' ? '新建规则' : '复制规则'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
      top="2vh"
    >
      <el-form
        :rules="rules"
        :model="ruleForm"
        ref="ruleForm"
        label-width="90px"
        class="demo-dynamic"
      >
        <el-form-item prop="ruleName">
          <span slot="label"> <span style="color: red">*</span>规则名称</span>
          <el-input
            v-model="ruleForm.ruleName"
            placeholder="请输入规则名称"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input
            type="textarea"
            v-model="ruleForm.remark"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item prop="separateChar">
          <span slot="label"> <span style="color: red">*</span>分隔符</span>
          <el-select v-model="ruleForm.separateChar" placeholder="请选择分隔符" style="width: 100%">
            <el-option
              v-for="item in separatorOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称结构" v-if="ruleForm.separateChar">
          <span>
            字符1{{ separatorText }}字符2{{ separatorText }}字符3{{ separatorText }}字符4{{
              separatorText
            }}
            字符5{{ separatorText }}字符6{{ separatorText }}字符7{{ separatorText }}字符8{{
              separatorText
            }}字符9{{ separatorText }}字符10{{ separatorText }} 字符11{{ separatorText }}字符12
          </span>
        </el-form-item>
        <el-form-item prop="matchChar">
          <span slot="label"> <span style="color: red">*</span>匹配字符</span>
          <el-select
            multiple
            v-model="ruleForm.matchChar"
            placeholder="请选择匹配字符"
            style="width: 100%"
          >
            <el-option
              v-for="item in matchCharOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="type">
          <span slot="label"> <span style="color: red">*</span>类型</span>
          <el-select
            @change="changeType(ruleForm.type)"
            v-model="ruleForm.type"
            placeholder="请选择类型"
            style="width: 100%"
          >
            <el-option
              v-for="item in materialRuleTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span class="tip" v-if="ruleForm.type === 6"
            >选择类型为标签时，在选择的这个字符之后全量匹配</span
          >
        </el-form-item>
        <el-form-item prop="ruleDatail" v-if="ruleForm.type === 6">
          <span slot="label"> <span style="color: red">*</span>规则详情</span>
          <el-cascader
            @change="changeCascader"
            style="width: 100%"
            placeholder="请选择规则"
            v-model="ruleForm.ruleDatail"
            :options="cascaderOptions"
            collapse-tags
            clearable
            :props="{ multiple: true, value: 'id', label: 'tagName' }"
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="ruleDatail" v-else>
          <span slot="label"> <span style="color: red">*</span>规则详情</span>
          <el-select
            multiple
            v-model="ruleForm.ruleDatail"
            @change="changeSelect"
            placeholder="请选择规则"
            style="width: 100%"
          >
            <el-option
              v-for="item in selectOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="ruleForm.ruleDatail && ruleForm.ruleDatail.length > 0"
          prop="tagRuleBOS"
          label=""
        >
          <el-table
            :data="ruleForm.tagRuleBOS"
            border
            size="mini"
            max-height="350px"
            v-if="ruleForm.type === 6"
          >
            <el-table-column prop="tagName" label="一级标签" width="140px"></el-table-column>
            <el-table-column prop="secondTagName" label="二级标签" width="140px"></el-table-column>
            <el-table-column prop="thirdTagName" label="三级标签" width="140px"></el-table-column>
            <el-table-column prop="keyword" label="匹配关键字">
              <template slot-scope="scope">
                <el-input v-model="scope.row.keyword" placeholder="请输入匹配关键字"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="ruleForm.tagRuleBOS" border size="mini" max-height="350px" v-else>
            <el-table-column
              prop="tagName"
              :label="materialRuleTypeOptions.find((item) => item.value === ruleForm.type).label"
              width="140px"
            ></el-table-column>
            <el-table-column prop="keyword" label="匹配关键字">
              <template slot-scope="scope">
                <el-input v-model="scope.row.keyword" placeholder="请输入匹配关键字"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  addTagAnalysis,
  getTagRuleList,
  modifyAnalysis,
  getTagPropertySelectList,
} from "@/api/property";
import { matchCharOptions, separatorOptions } from "./config";
import { materialRuleTypeOptions } from "@/config/fieldData";
export default {
  components: {},

  data() {
    return {
      materialRuleTypeOptions,
      matchCharOptions,
      separatorOptions,
      dialogVisible: false,
      checked: false,
      ruleForm: {},
      rules: {
        ruleName: [{ required: true, message: "请输入规则名称", trigger: "change" }],
        separateChar: [{ required: true, message: "请选择分隔符", trigger: "change" }],
        matchChar: [{ required: true, message: "请选择匹配字符", trigger: "change" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        ruleDatail: [{ required: true, message: "请选择规则详情", trigger: "blur" }],
        tagRuleBOS: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              let flag = true;
              value.map((item) => {
                if (!item.keyword) {
                  flag = false;
                }
              });
              flag ? callback() : callback(new Error("请补全标签对应的匹配关键字"));
            },
          },
        ],
      },
      cascaderOptions: [],
      selectOptions: [],
      loading: false,
      modalType: "",
    };
  },
  computed: {
    separatorText() {
      return this.separatorOptions.find((item) => item.value === this.ruleForm.separateChar)?.key;
    },
  },
  methods: {
    async openModal(type, row) {
      this.$refs.ruleForm?.clearValidate();
      this.modalType = type;
      if (this.modalType === "add") {
        this.ruleForm = {
          ruleName: "",
          remark: "",
          separateChar: "",
          matchChar: [],
          ruleDatail: [],
          tagRuleBOS: [],
          type: "",
        };
      } else {
        await this.changeType(row.type);
        const { ruleName, remark, separateChar, matchChar, tagRuleList, type, id } = row;
        this.ruleForm = {
          id,
          ruleName,
          remark,
          separateChar,
          matchChar: matchChar.split(","),
          ruleDatail:
            type == 6
              ? tagRuleList.map((item) => {
                  return [item.tagId1, item.tagId2, item.tagId3];
                })
              : tagRuleList.map((item) => item.matchTagId),
          tagRuleBOS:
            type == 6
              ? tagRuleList.map((item) => {
                  item.tagName = item.tagName1;
                  item.secondTagName = item.tagName2;
                  item.thirdTagName = item.matchTagName;
                  return item;
                })
              : tagRuleList.map((item) => {
                  item.tagName = item.matchTagName;
                  return item;
                }),
          type,
        };
      }
      this.dialogVisible = true;
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { matchChar, remark, ruleName, separateChar, tagRuleBOS, type, id } = this.ruleForm;
          const tagRuleArr = tagRuleBOS.map((item) => {
            return {
              tagName1: item.tagName,
              tagName2: item.secondTagName,
              tagName3: item.thirdTagName,
              tagId1: item.tagId1,
              tagId2: item.tagId2,
              tagId3: item.tagId3,
              keyword: item.keyword,
              matchTagName: type == 6 ? item.thirdTagName : item.tagName,
              id: item.id,
            };
          });
          if (this.modalType === "edit") {
            modifyAnalysis({
              id,
              matchChar: matchChar.join(","),
              remark,
              ruleName,
              separateChar,
              type,
              tagRuleBOS: tagRuleArr,
            }).then((res) => {
              if (res.code === "0000") {
                this.dialogVisible = false;
                this.$message.success("编辑成功");
                this.$emit("callBackSuccess");
              }
            });
          } else {
            addTagAnalysis({
              matchChar: matchChar.join(","),
              remark,
              ruleName,
              separateChar,
              type,
              tagRuleBOS: tagRuleArr,
            }).then((res) => {
              if (res.code === "0000") {
                this.dialogVisible = false;
                this.$message.success(this.modalType === "add" ? "添加成功" : "复制成功");
                this.$emit("callBackSuccess");
              }
            });
          }
        } else {
          this.$message.error("表单未填写完成");
          return false;
        }
      });
    },
    changeCascader() {
      const originTable = JSON.parse(JSON.stringify(this.ruleForm.tagRuleBOS));
      this.ruleForm.tagRuleBOS = [];
      if (this.ruleForm.ruleDatail.length > 0) {
        this.ruleForm.ruleDatail.map((item) => {
          // // 取出原表格数据的importantKey值
          const firstObj = this.cascaderOptions.find((v) => v.id === item[0]);
          const secondObj = firstObj?.children.find((v) => v.id === item[1]);
          const thirdObj = secondObj?.children.find((v) => v.id === item[2]);
          const tableObj =
            originTable.find((v) => v.id === item[2] || v.matchTagId === item[2]) || {};

          this.ruleForm.tagRuleBOS.push({
            id: thirdObj?.id,
            tagId1: firstObj?.id,
            tagId2: secondObj?.id,
            tagId3: thirdObj?.id,
            tagName: firstObj?.tagName,
            secondTagName: secondObj?.tagName,
            thirdTagName: thirdObj?.tagName,
            keyword: tableObj.keyword || thirdObj?.tagName,
          });
        });
      }
    },
    changeSelect() {
      const originTable = JSON.parse(JSON.stringify(this.ruleForm.tagRuleBOS));
      this.ruleForm.tagRuleBOS = [];
      if (this.ruleForm.ruleDatail.length > 0) {
        this.ruleForm.ruleDatail.map((item) => {
          // // 取出原表格数据的importantKey值
          const findObj = this.selectOptions.find((v) => v.id === item);
          const tableObj = originTable.find((v) => v.matchTagId === item || v.id === item) || {};
          console.log(tableObj, findObj);
          this.ruleForm.tagRuleBOS.push({
            id: item,
            tagId1: item,
            tagName: findObj.name,
            keyword: tableObj.keyword || findObj.name,
          });
        });
      }
    },
    changeType(type) {
      if (type) {
        if (type == 6) {
          getTagRuleList().then((res) => {
            this.cascaderOptions = res.data;
          });
        } else {
          getTagPropertySelectList({
            type,
          }).then((res) => {
            this.selectOptions = res.data;
          });
        }
      } else {
        this.cascaderOptions = [];
      }
      this.ruleForm.ruleDatail = [];
      this.ruleForm.tagRuleBOS = [];
    },
  },
};
</script>

<style lang="less" scoped>
.add-rule-modal {
  .tip {
    font-size: 12px;
    color: #777;
  }
}
</style>
<style lang="less">
.property-add-rule-modal {
  .select-top {
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
    height: 30px;
    line-height: 36px;
  }
}
</style>
